import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'I', label: 'Entrada' },
			{ value: 'O', label: 'Saída' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

